export default "__VITE_ASSET__CaF6jDAR__"